import { FC, useCallback } from 'react'
import InteractiveBadge from '../InteractiveBadge/InteractiveBadge'
import { Participant, BadgeName } from 'src/app/types'
import AddBadge from '../AddBadge/AddBadge'
import { useAppDispatch } from 'src/hooks'
import { incrementBadge, setBadgeCount } from 'src/app/session'

type ParticipantProps = {
  screenName: Participant['screenName']
  badges: Participant['badges']
}

const HostParticipant: FC<ParticipantProps> = ({ screenName, badges }) => {
  const dispatch = useAppDispatch()
  const increment = useCallback(
    (name: BadgeName) =>
      dispatch(
        incrementBadge({
          screenName,
          name,
        })
      ),
    [screenName, dispatch]
  )
  const setCount = useCallback(
    ({ name, count }: { name: BadgeName; count: number }) =>
      dispatch(
        setBadgeCount({
          screenName,
          name,
          count,
        })
      ),
    [dispatch, screenName]
  )
  return (
    <>
      <p className="font-[510]">{screenName}</p>
      <div className="inline-flex content-center">
        {badges.map(({ name, count }) => (
          <InteractiveBadge
            setBadgeCount={setCount}
            name={name}
            initialCount={count}
            key={name}
          />
        ))}
        <AddBadge onClick={increment} />
      </div>
    </>
  )
}

export default HostParticipant
